import React from 'react';

//components
import { AvailabilityDropdown } from '../../storyboard/common';

function HeaderInterventions(props) {
    const { value, index, toggleCategory, toggleIntervention, handleAllAvailable } = props && props;
    return (
        <React.Fragment key={index}>
            <div className="d-flex align-items-center mb-3">
                <button
                    className="btn btn-danger"
                    onClick={() => toggleCategory("deleteCategory", value)}
                >
                    Delete
                </button>
                <button
                    className="btn btn-brand d-block ml-auto"
                    onClick={() =>
                        toggleIntervention("add", value, value.CategoryId)
                    }
                >
                    <i className="fa fa-plus"></i> Add {value.Name}
                </button>
                {value?.Interventions?.length > 0 && (
                    <AvailabilityDropdown
                        index={index}
                        value={value}
                        handleAllAvailable={handleAllAvailable}
                    />
                )}
            </div>
            <p className="mb-3 --text-primary">(*) score applies only to this time point</p>
        </React.Fragment>
    );
};

export default HeaderInterventions;